import { Box } from '@chakra-ui/react'
import React from 'react'

const Index = () => {
    return (
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
            <div>This is default dunction of clark</div>
        </Box>
    )
}

export default Index